import {
  APPROVED_STATUSES,
  IntegrationRedirectStatuses,
  OPERATION_STATUS,
  PROCESSING_STATUSES,
} from '@linqpal/models/src/dictionaries'

export const determinePaymentStatus = (
  paymentStatus: string | null,
  creditStatus: string | null,
) => {
  if (
    (paymentStatus &&
      [OPERATION_STATUS.PROCESSING, OPERATION_STATUS.SUCCESS].find(
        (stat) => stat === paymentStatus,
      )) ||
    (creditStatus &&
      [...PROCESSING_STATUSES, ...APPROVED_STATUSES].find(
        (stat) => stat === creditStatus,
      ))
  ) {
    return IntegrationRedirectStatuses.NoActionsNeeded
  } else {
    return IntegrationRedirectStatuses.SomethingWentWrong
  }
}
